import {type ComponentType, type LazyExoticComponent} from 'react';
import {LoginPage} from 'pages/login';
import {RegisterPage} from 'pages/register';
import {NotFoundPage} from 'pages/notFound';
import {Recover} from 'widgets/recover';
import {DiaryPage} from 'pages/diary';
import {HivesPage} from 'pages/hives';
import HivePage from 'pages/hive/ui/hivePage.tsx';
import {HiveBack, HiveTitleRight} from 'features/hive';
import {NotificationsPage} from 'pages/notifications';
import {CalendarPage} from 'pages/calendar';
import {WeatherPage} from '../../pages/weather';
import {HomePage} from 'pages/homePage';
import {Dashboard} from '../../widgets/dashboard';
import {ChartPage} from 'pages/chartPage';
import {DevicesPage} from '../../pages/devices';
import {WeatherDay} from 'widgets/weatherDay';
import {PesticideMapPage} from 'pages/pesticideMap';
import {ApiarySchemePage} from 'pages/apiaryScheme';
import {EmployeesPage} from 'pages/employees';
import {HiveAudiosPage} from 'pages/hiveAudios';
import {BreedingPortalPage} from 'pages/breedingPortal';
import {HoneyExchangePage} from 'pages/honeyExchange';
import {DiaryTitleRight} from 'features/diary';
import {DevicesTitleRight} from 'features/devices';
import DevicesInfoPage from '../../pages/devicesInfoPage/ui/DevicesInfoPage.tsx';
import {HorriotPage} from 'pages/horriot/index.ts';
import {MercuryPage} from 'pages/mercury/index.ts';
import {HorriotPageView} from 'pages/horriot/ui/HorriotPageView.tsx';
import {ServicesPage} from 'pages/servicesPage';
import {PersonalDataConsentPage} from 'pages/personalDataConsent';

export type ElementType = ComponentType<unknown> | LazyExoticComponent<ComponentType<unknown>>;

export type AppRoute = {
  path: string;
  element: ElementType;
  title: string | ((params: Record<string, string>) => string);
  titleRightCol?: ElementType; // контент справа от h1 страницы
  noLayout?: boolean; // отключить Layout (HUD и Заголовок)
  guestOnly?: boolean; // если true — редиректим авторизованных на "/"
  parentPath?: string; // для хлебных крошек, указывается path родителя
  upperTitleMobile?: ElementType;
  adminOnly?: boolean;
};

// const HomePage = lazy(() =>
//     import("pages/homePage").then(m => ({ default: m.HomePage })),
// );

export const routes: AppRoute[] = [
  {
    path: '/',
    element: HomePage,
    title: 'Моя пасека',
  },
  {
    path: '/oauth/realms/:realm/login/:type?',
    element: LoginPage,
    title: 'Вход',
    noLayout: true,
    guestOnly: true,
  },
  {
    path: '/oauth/realms/:realm/registration/:step?',
    element: RegisterPage,
    title: 'Регистрация',
    noLayout: true,
    guestOnly: true,
  },
  {
    path: '/oauth/realms/:realm/recovery-password/:step?',
    element: Recover,
    title: 'Восстановление пароля',
    noLayout: true,
    guestOnly: true,
  },
  {
    path: '/personal-data-consent',
    element: PersonalDataConsentPage,
    title: 'Согласие на обработку персональных данных',
    noLayout: true,
  },
  {
    path: '/diary',
    element: DiaryPage,
    titleRightCol: DiaryTitleRight,
    title: 'Журнал пчеловода',
  },
  {
    parentPath: '/',
    path: '/hives',
    element: HivesPage,
    title: 'Ульи',
    titleRightCol: HiveTitleRight,
  },
  {
    parentPath: '/hives',
    path: '/hive/:id',
    element: HivePage,
    upperTitleMobile: HiveBack,
    title: 'Улей',
    // titleRightCol: HiveTitleRight,
  },
  {
    path: '/notifications',
    element: NotificationsPage,
    title: 'Уведомления',
  },
  {
    path: '/services',
    element: ServicesPage,
    title: 'Наши сервисы',
  },
  {
    path: '/calendar',
    element: CalendarPage,
    title: 'Календарь',
  },
  {
    path: '/weather',
    element: WeatherPage,
    title: 'Погода на пасеке',
  },
  {
    parentPath: '/weather',
    path: '/weather/:date',
    element: WeatherDay,
    title: 'Погода на пасеке',
  },
  {
    path: '/dashboard',
    element: Dashboard,
    title: 'Погода на пасеке',
  },
  {
    parentPath: '/',
    path: '/pesticide-map',
    element: PesticideMapPage,
    title: 'Карта пестицидов',
  },
  {
    parentPath: '/hives',
    path: '/hive/:id/analytics',
    element: HivePage,
    title: 'Улей',
    upperTitleMobile: HiveBack,
    titleRightCol: HiveTitleRight,
  },
  {
    parentPath: '/hive/:id/analytics',
    path: '/hive/:id/analytics/:chartId',
    element: HivePage,
    title: 'Улей',
    upperTitleMobile: HiveBack,
  },
  {
    parentPath: '/',
    path: '/charts/:chartId',
    element: ChartPage,
    title: 'График',
    upperTitleMobile: HiveBack,
  },
  {
    parentPath: '/',
    path: '/devices',
    element: DevicesPage,
    title: 'Управление устройствами',
    titleRightCol: DevicesTitleRight,
  },
  {
    parentPath: '/devices',
    path: '/devices/info',
    element: DevicesInfoPage,
    title: 'Об устройствах',
  },
  {
    parentPath: '/',
    path: '/scheme',
    element: ApiarySchemePage,
    title: 'Схема пасеки',
  },
  {
    parentPath: '/',
    path: '/employees',
    element: EmployeesPage,
    title: 'Сотрудники',
  },
  {
    parentPath: '/',
    path: '/hive-audios',
    element: HiveAudiosPage,
    title: 'Аудиозаписи ульев',
  },
  // {
  //   parentPath: '/',
  //   path: '/horriot',
  //   element: HorriotPage,
  //   title: 'Ветеринарный учёт',
  //   adminOnly: true,
  // },
  // {
  //   parentPath: '/',
  //   path: '/horriot/view',
  //   element: HorriotPageView,
  //   title: 'Ветеринарный учёт',
  //   adminOnly: true,
  // },
  // {
  //   parentPath: '/',
  //   path: '/mercury/:viewType?',
  //   element: MercuryPage,
  //   title: 'ВСД',
  //   adminOnly: true,
  // },
  {
    parentPath: '/',
    path: '/breeding-portal',
    element: BreedingPortalPage,
    title: 'Селекционный портал',
  },
  {
    parentPath: '/',
    path: '/honey-exchange',
    element: HoneyExchangePage,
    title: 'Медовая биржа',
  },
  {
    path: '*',
    element: NotFoundPage,
    title: 'Страница в разработке',
  },
];

export const archivedBlockedPaths = [
  '/',
  '/hives',
  '/hive',
  '/scheme',
  '/devices',
  '/charts',
  '/weather',
  '/calendar',
  '/notifications',
  '/diary',
];
